import { apiClient } from '@/shared/api'

import { TPartnership } from '../model/schema'

export const getPartnerships = async () => {
  const response = await apiClient.get<TPartnership[]>({
    endpoint: '/campaigns/partnerships',
  })

  return response
}
